export default {"src":"/_next/static/media/wikipedia-icon.efc08f25.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};